import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../app.constants';

import { UserRouteAccessService } from '../shared';
import {UserClubUnsubscribeComponent} from './user-club-unsubscribe/user-club-unsubscribe.component';

export const UserClubRoute: Route = {
    path: 'club',
    children: [
        {
            path: 'desinscription',
            component: UserClubUnsubscribeComponent,
            data: {
                needAuthentication: true,
                pageTitle: `Désinscription du club utilisateur${PAGE_TITLE_SUFFIX}`
            },
            canActivate: [UserRouteAccessService]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/user-club/user-club.route.ts